import { twMerge } from "tailwind-merge";
import Type from "@themes/pollinator/ui/Type";
import Badge from "@themes/pollinator/ui/Badge";
import { MeetingRole } from "@platform/types/platform.types";

export type Props = {
  badgeClassName?: string;
  className?: string;
  role: MeetingRole;
};

export function ProgramMeetingRoleBadge({
  badgeClassName,
  className,
  role,
}: Props) {
  if (!role) return null;

  return (
    <Type variant="h6" className={twMerge(className)}>
      <Badge className={twMerge("bg-brand-100 self-start", badgeClassName)}>
        {role.name}
      </Badge>
    </Type>
  );
}

export default ProgramMeetingRoleBadge;

